var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"popup__image",attrs:{"src":_vm.image,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }